<template>
    <div class="resource_subject_wrap">
        <div class="header">
            <el-button size="medium" type="primary" @click="jumpToPage('watchingRecordsSettingAddEdit')">新增视察指南</el-button>
        </div>
        <div class="resource_subject_box" :style="`height: ${windowHeight - 100}px;`">
            <div class="subject_box" v-if="dataList && dataList.length">
                <div class="resource_item" :style="`background: url(${item.logoUrl ? item.logoUrl : 'https://cdnfile-10043692.file.myqcloud.com/admin/images/resource_manage/bg'+ (index%4 + 1) +'.png'}) center center /cover no-repeat;`"
                    @click="jumpToPage('watchingRecordsSettingDetail', {id: item.id, gradeLevel: item.gradeLevel})" :key="item.id" v-for="(item, index) in dataList">
                    <div class="center_text">{{['', '3-4岁', '4-5岁', '5-6岁'][item.gradeLevel]}}</div>
                    <i class="el-icon-delete" @click.stop="deleteHandler(item.id)"></i>
                </div>
            </div>
            <div class="no_stu_msg" v-else>
                <img src="https://cdnfile-10043692.file.myqcloud.com/class_brand/gridClasscard/nodata/elastic-nodata2.png"
                     alt="">
                <div>暂无指南</div>
            </div>
        </div>
    </div>
</template>

<script>
    import windowResize from '@/mixins/windowResize'
    import {
        getAgePriodGuideList,
        deleteChildLearnDevelopGuideById
    } from '@/api/watchingRecords'

    export default {
        name: "watchingRecordsSettingList",
        data() {
            return {
                dataList: []
            }
        },
        mixins: [windowResize],
        created() {
            this.getAgePriodGuideListFunc();
        },
        methods: {
            jumpToPage(path, query = {}) {
                this.$router.push({
                    path,
                    query
                })
            },
            getAgePriodGuideListFunc() {
                getAgePriodGuideList()
                    .then(res => res.data)
                    .then(data => {
                        this.dataList = data.data;
                    });
            },
            deleteHandler(id) {
                this.$confirm("确认要删除该指南吗？", "删除", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    lockScroll: false
                }).then(() => {
                    deleteChildLearnDevelopGuideById({
                        id
                    })
                        .then(res => res.data)
                        .then(data => {
                            if(data.result) {
                                this.$message.success('删除成功');
                                this.getAgePriodGuideListFunc();
                            }
                        })
                })

            }
        }
    }
</script>

<style lang="scss" scoped>
    @import './../../styles/mixin';

    .resource_subject_wrap {
        padding: 12px;
        .header{
            padding-bottom: 10px;
            border-bottom: 1px solid #eee;
        }
        .resource_subject_box{
            @include scrollBar;
            .subject_box{
                @include clearfix;
                padding: 10px 0;

                .resource_item{
                    float: left;
                    position: relative;
                    width: 176px;
                    height: 260px;
                    margin-top: 20px;
                    margin-right: 15px;
                    margin-left: 10px;
                    overflow: hidden;
                    cursor: pointer;
                    transition: all .2s linear;
                    background: #ededed;
                    border-radius: 5px;
                    .center_text {
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        width: 100%;
                        height: 30px;
                        line-height: 30px;
                        text-align: center;
                        font-size: 14px;
                        color: #fff;
                        background: #ccc;
                        background: rgba(0,0,0,.3);
                    }

                    i{
                        position: absolute;
                        top: 10px;
                        right: 40px;
                        color: #409eff;
                        font-weight: bold;
                        display: none;
                    }
                    .el-icon-delete{
                        right: 10px;
                        color: #f56c6c;
                    }

                    &:hover {
                        box-shadow: 5px 5px 10px rgba(0, 0, 0, .05), -5px 0 10px rgba(0, 0, 0, .05);
                        transform: translate3d(0, -4px, 0);
                        i{
                            display: block;
                        }
                    }
                }
            }
            .no_stu_msg {
                text-align: center;
                font-size: 15px;
                color: #999;
                overflow: hidden;

                img {
                    display: block;
                    margin: 30px auto 0;
                }

                div {
                    height: 20px;
                    line-height: 20px;
                    margin-top: -40px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/watchingRecords/watchingRecordsSettingList.vue